<template>
    <modal
        name="image-details"
        @before-open="beforeOpen"        
        @before-close="beforeClose"
        :classes="['v--modal', 'photo']"
        :width="960"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
    > 
        <div class="photo-main photo-main-message">
            <!-- <div
                @click="$modal.hide('image-details')"
                class="photo-close"
            >&times;</div> -->
            <span
                @click="$modal.hide('image-details')"
                class="photo-back photo-back-image"
            ></span>
            <div class="photo-wrapper">
                <img
                    :src="image"
                    alt=""
                    class="photo-img"
                >
            </div>
        </div>
    </modal>
</template>

<script>
    import {checkScroll} from '@/mixins/checkScroll';

    export default {
        name: 'ImageDetails',
        mixins: [
            checkScroll
        ],
        data() {
            return {
                image: ''
            }
        },
        watch: {
            '$route' (to, from) {
                if (to != from) {
                    this.$modal.hide('image-details');
                }
            }
        },
        methods: {
            beforeOpen(event) {
                this.checkScroll();
                this.image = event.params.image;
            },
            beforeClose() {
                this.checkRemoveScroll();
            },
        }
    }
</script>

<style lang="scss">
    @import '~@/assets/styles/layout/_photo-details';    
</style>